/* eslint-disable no-undef */
import axios from "axios";
import { updateUserStartAction, updateUserSuccessAction, updateUserFailAction } from "../actions";
import { successAlert, failAlert } from "../../../helper";

const updateUser =
  (user_id, value, token, newActivityStatus, accept_extra_message, data, classes, autoReplies) =>
  async (dispatch) => {
    dispatch(updateUserStartAction());
    try {
      if (data !== undefined) dispatch(updateUserSuccessAction(data));
      else if (newActivityStatus !== undefined) {
        await axios.patch(
          `/api/v1/user?activity_status=${newActivityStatus}`,
          {},
          {
            headers: {
              Authorization: token,
            },
          },
        );
        dispatch(updateUserSuccessAction({ activity_status: newActivityStatus }));
        successAlert("Your activity status is updated successfully");
      } else if (accept_extra_message !== undefined) {
        await axios.patch(
          `/api/v1/user?accept_extra_message=${accept_extra_message}`,
          {},
          {
            headers: {
              Authorization: token,
            },
          },
        );
        dispatch(updateUserSuccessAction({ accept_extra_message }));
      } else {
        const keys = Object.keys(value);
        const values = Object.values(value);
        const bodyFormData = new FormData();

        keys.forEach((key, i) => {
          bodyFormData.append(keys[i], values[i]);
        });

        await axios.patch(`/api/v1/user?updateAllUser=true`, bodyFormData, {
          headers: {
            Authorization: token,
            "Content-Type": `multipart/form-data; boundary=${bodyFormData._boundary}`,
          },
        });
        dispatch(
          updateUserSuccessAction({
            ...value,
          }),
        );
        successAlert(
          autoReplies
            ? "Your auto replies updated successfully"
            : "Your profile updated successfully", // we need this in add payment method
          1500,
          classes,
        );
      }
    } catch (error) {
      const errorMsg = error?.response?.data?.error?.msg;
      dispatch(updateUserFailAction(errorMsg || "Something went wrong, please try again!"));
      failAlert(errorMsg, null, null, 2000);
    }
  };

export default updateUser;
